import React from "react";

const GPS = ({ style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36" }) => (
    <svg 
    width={size}
    style={style}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink">
        <path
        className="u_fill"
            fill={fill}
            d="m19.5 1.5.002 4.593A12.006 12.006 0 0 1 29.907 16.5H34.5v3l-4.593.002a12.006 12.006 0 0 1-10.405 10.405L19.5 34.5h-3v-4.593A12.006 12.006 0 0 1 6.093 19.502L1.5 19.5v-3h4.593A12.006 12.006 0 0 1 16.5 6.093V1.5h3ZM18 9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
        />
    </svg>

);

export default GPS;